// extracted by css-extract-rspack-plugin
export default {"container":"link-module__container___I5_Qa"};